import { Component } from 'react';
import MobileNavigation from 'components/molecules/MobileNavigation';
import Header from 'components/organisms/Header';
import Footer from 'components/organisms/Footer';
import Carousel from 'components/organisms/Carousel';
import CarouselSlide from 'components/molecules/CarouselSlide';
import ContactForm from 'components/organisms/ContactForm';
import slideImageContact from 'images/contact.jpg';

import './Contact.scss';

class Contact extends Component {
  scrollToForm() {
    const top = document.getElementById('form').offsetHeight;

    window.scroll(0, top + 100);
  }

  render() {
    return (
      <div>
        <MobileNavigation />
        <Header />
        <Carousel noNav>
          <CarouselSlide
            type="light"
            src={slideImageContact}
            title="Av. San Martín Sur 719"
            text="Godoy Cruz, Mendoza, Argentina"
            subtitle="Visitános en"
            buttonText="Contactanos"
            onClick={() => this.scrollToForm()}
            target="_blank"
            rel="noopener noreferrer"
            status="active"
          />
        </Carousel>
        <div className="pageContent">
          <div className="container">
            <div className="contactLocations">
              <div className="contactLocations__location">
                <h3>Mendoza</h3>
                <p>
                  Av. San Martín Sur 600
                  <br />
                  Godoy Cruz, Mendoza, Argentina.
                  <br /> <br />
                  <a
                    href="https://maps.app.goo.gl/MhYxXwrsgUR1wRAb6"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver en Mapa
                  </a>
                </p>
              </div>
              <div className="contactLocations__location">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1674.4155028051744!2d-68.85031940000002!3d-32.9290629!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x967e0bd6f9c4ffb5%3A0xb64a493bc8acff07!2sAv.%20San%20Mart%C3%ADn%20Sur%20600%2C%20M5501%20Godoy%20Cruz%2C%20Mendoza%2C%20Argentina!5e0!3m2!1ses-419!2ses!4v1753462266065!5m2!1ses-419!2ses" width="100%" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="contactData">
              <div className="contactData__main">
                <h3>Contacto</h3>
                <p>Contactanos por teléfono:</p>
                <p>
                  <strong>Directo:</strong> +54 261 4439300 <br />
                  <strong>WhatsApp:</strong>{' '}
                  <a
                    href="https://wa.me/5492616548107"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    +54 9 2615 33-6863
                  </a>{' '}
                  <br />
                  <strong>Venta Directa y Administración:</strong> +54 261 6856042 <br />
                  <strong>Servicio:</strong> +54 261 5725893
                </p>

                <p>
                  <a
                    href="https://www.facebook.com/YacopiniNissan/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Facebook
                  </a>
                  <br />
                  <a
                    href="https://twitter.com/YacopiniNissan"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Twitter
                  </a>
                  <br />
                  <a
                    href="https://twitter.com/search?q=yacopini%20nissan&src=typd"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Instagram
                  </a>
                  <br />
                  <a
                    href="https://www.youtube.com/channel/UCaII_9QKsBYfnlUwhrQaE1g"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    YouTube
                  </a>
                </p>
              </div>
              <div className="contactData__hours">
                <h3>Horarios</h3>
                <p>
                  <strong>Ventas</strong>
                  <br />
                  Lunes a Viernes: 10:00 a 14:00 - 15:00 a 19:00
                  <br />
                  Sábados: 10:00 a 13:00
                </p>
                <p>
                  <strong>Administración</strong>
                  <br />
                  Lunes a Viernes: 10:00 a 14:00 - 15:00 a 19:00
                </p>
                <p>
                  <strong>Postventa</strong>
                  <br />
                  Lunes a Viernes: 08:00 a 14:00 - 15:00 a 19:00
                </p>
              </div>
              <div className="contactData__services">
                <h3>Servicios</h3>
                <div className="serviceItem">Venta de 0km</div>
                <div className="serviceItem">Postventa</div>
              </div>
            </div>
          </div>

          <div className="pageContent">
            <div className="container">
              <div className="contactLocations">
                <div className="contactLocations__location">
                  <h3>San Rafael</h3>
                  <p>
                    Av. Bartolomé Mitre 530
                    <br />
                    San Rafael, Mendoza , Argentina.
                    <br /> <br />
                    <a
                      href="https://goo.gl/maps/FkETu1WpF7ke81mv8"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ver en Mapa
                    </a>
                  </p>
                </div>
                <div className="contactLocations__location">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3283.3977100364664!2d-68.3262676!3d-34.6193886!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x967907f8397b7ac5%3A0x883f263c4cc17813!2sAv.%20Bartolom%C3%A9%20Mitre%20530%2C%20M5602%20San%20Rafael%2C%20Mendoza%2C%20Argentina!5e0!3m2!1sen!2ses!4v1753462366576!5m2!1sen!2ses" width="100%" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="contactData">
                <div className="contactData__main">
                  <h3>Contacto</h3>
                  <p>Contactanos por teléfono:</p>
                  <p>
                    <strong>Directo:</strong> +54 260 4420261<br />
                    <strong>Venta Directa y Administración:</strong> +54 260 4843713<br />
                    <strong>Postventa:</strong> +54 260 4048500
                    <br />
                  </p>
                </div>
                <div className="contactData__hours">
                  <h3>Horarios</h3>
                  <p>
                    <strong>Ventas</strong>
                    <br />
                    Lunes a Viernes: 09:00 a 13:00 - 16:00 a 20:00
                    <br />
                    Sábados: 10:00 a 13:00
                  </p>
                  <p>
                    <strong>Administración</strong>
                    <br />
                    Lunes a Viernes: 09:00 a 13:00 - 16:00 a 20:00
                  </p>
                  <p>
                    <strong>Postventa</strong>
                    <br />
                    Lunes a Viernes:  09:00 a 13:00 - 16:00 a 20:00
                  </p>
                </div>
                <div className="contactData__services">
                <h3>Servicios</h3>
                <div className="serviceItem">Venta de 0km</div>
                <div className="serviceItem">Postventa</div>
              </div>
              </div>
            </div>
          </div>

          <div className="pageContent">
            <div className="container">
              <div className="contactLocations">
                <div className="contactLocations__location">
                  <h3>San Juan</h3>
                  <p>
                    Paula Albarracín de Sarmiento 699
                    <br />
                    San Juan, Argentina.
                    <br /> <br />
                    <a
                      href="https://maps.app.goo.gl/FC64UdRxVkcXigfW8"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ver en Mapa
                    </a>
                  </p>
                </div>
                <div className="contactLocations__location">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.0775406578828!2d-68.556112!3d-31.522030199999993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x968141b098c810b1%3A0x24e36fa0fb93bb8a!2sPaula%20Albarrac%C3%ADn%20de%20Sarmiento%20Nte.%20699%2C%20J5400%20San%20Juan%2C%20Argentina!5e0!3m2!1sen!2ses!4v1753462395589!5m2!1sen!2ses" width="100%" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="contactData">
                <div className="contactData__main">
                  <h3>Contacto</h3>
                  <p>Contactanos por teléfono:</p>
                  <p>
                    <strong>Directo:</strong> +54 264 4312631 <br />
                    <strong>Recepción y Venta Directa solo WhatsApp:</strong>{' '}
                    <a
                      href="https://wa.me/5492646716604"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +54 9 264 6716604 
                    </a><br />
                    <strong>Administración solo WhatsApp:</strong>{' '}
                    <a
                      href="https://wa.me/5492646617079"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +54 9 264 6617079
                    </a><br />
                    <strong>Postventa solo WhatsApp:</strong>{' '}
                    <a
                      href="https://wa.me/5492644175149"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +54 264 4175149
                    </a><br />
                  </p>
                </div>
                <div className="contactData__hours">
                  <h3>Horarios</h3>
                  <p>
                    <strong>Ventas</strong>
                    <br />
                    Lunes a Viernes: 10:00 a 14:00 - 15:00 a 19:00
                    <br />
                    Sábados: 10:00 a 13:00
                  </p>
                  <p>
                    <strong>Administración</strong>
                    <br />
                    Lunes a Viernes: 9:00 a 14:00 - 15:00 a 19:00
                  </p>
                  <p>
                    <strong>Postventa</strong>
                    <br />
                    Lunes a Viernes: 9:00 a 14:00 - 15:00 a 19:00
                  </p>
                </div>
                <div className="contactData__services">
                  <h3>Servicios</h3>
                  <div className="serviceItem">Venta de 0km</div>
                  <div className="serviceItem">Postventa</div>
                </div>
              </div>
            </div>
          </div>

          <div className="container" id="form">
            <ContactForm />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Contact;
